import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=1c7b7618&lang=scss&scoped=true"

import exportComponent from "/Users/lgd_sunday/Desktop/langChain/wwzhidao-admin/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c7b7618"]])

export default __exports__